import { render, staticRenderFns } from "./SrInputLabel.vue?vue&type=template&id=698ea8a3"
import script from "./SrInputLabel.vue?vue&type=script&lang=js"
export * from "./SrInputLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports